export const normalizeNumberInput = (value: string) => value.trim().replace(',', '.');

export const parseNumber = (value: string) => Number(normalizeNumberInput(value));
